import { Component, OnInit, Signal } from '@angular/core';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { BaseCardsContactComponent } from './base-cards/base-cards-contact/base-cards-contact.component';
import { BaseCardsOpeningHoursComponent } from './base-cards/base-cards-opening-hours/base-cards-opening-hours.component';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-c-cards-side-by-side',
    imports: [
        CommonModule,
        SHeaderComponent,
        BaseCardsContactComponent,
        BaseCardsOpeningHoursComponent
    ],
    templateUrl: './c-cards-side-by-side.component.html',
    styleUrl: './c-cards-side-by-side.component.scss'
})
export class CCardsSideBySideComponent extends CBaseComponent implements OnInit { 
  
  public isLargeScreen$: Signal<boolean> = this.screensizeState.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.Medium, ScreenWidthBreakpoints.Large, ScreenWidthBreakpoints.XLarge]);
  
  constructor(private screensizeState: ScreensizeStateService) { 
    super();
  }
  
  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader];
    super.ngOnInit();
  }

}
